import { Sparkles } from "lucide-react"
import { GuidedSectionChat } from "./GuidedSectionChat"

// Prominent "talk to an AI coach" CTA for open-text intake steps. Sits at
// the top of the step, above the form. Wraps GuidedSectionChat so the
// dialog still handles the back-and-forth chat and the "Use this" bullets.
//
// Props:
//   section: one of the IntakeGuideService::SECTIONS keys
//   onInsert: (bullets: string[]) => void — called when the user hits
//             "Use this" on the assistant's <guide-output> block
//   title:    CTA heading
//   subtitle: CTA supporting copy
export function GuideMeCta({ section, onInsert, title, subtitle }) {
  return (
    <div className="rounded-lg border border-kf-red/30 bg-kf-red/5 p-4 sm:p-5 mb-5">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <Sparkles className="w-6 h-6 text-kf-red shrink-0" />
        <div className="flex-1">
          <p className="font-semibold text-zinc-900 text-base">{title}</p>
          {subtitle && (
            <p className="text-sm text-zinc-600 mt-0.5">{subtitle}</p>
          )}
        </div>
        <GuidedSectionChat section={section} onInsert={onInsert} variant="cta" />
      </div>
      <p className="text-xs text-zinc-500 mt-3 sm:ml-9">
        Or skip the chat and fill in the form below directly.
      </p>
    </div>
  )
}
